import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
export var contextToEventMapper = {
    /**
     * TODO: Add all the events that Office.com needs from FAST Search.
     * PBI: https://msfast.visualstudio.com/FAST%20Experiences/_workitems/edit/566127
     */
    'AllSearchPanel.AppSearchResult.onClick': function () { return [
        {
            itemCategory: "Result" /* SearchResultClickType.Result */,
            knownArea: 'SearchResults',
            searchProviderType: "All" /* SearchResultType.All */,
            searchResultType: "App" /* SearchResultType.App */,
            event: KnownInstrumentationEvents.SearchClick,
            elementId: "MSA_Serp_App" /* SerpResultElementId.App */,
            pageNav: true,
        },
    ]; },
    'AllSearchPanel.TriageFileSearchResult.onClick': function () { return [
        {
            itemCategory: "Result" /* SearchResultClickType.Result */,
            knownArea: 'SearchResults',
            searchProviderType: "All" /* SearchResultType.All */,
            searchResultType: "File" /* SearchResultType.File */,
            event: KnownInstrumentationEvents.SearchClick,
            elementId: "MSA_Serp_File" /* SerpResultElementId.File */,
            pageNav: true,
        },
    ]; },
    'AllSearchPanel.TemplateSearchResult.onClick': function () { return [
        {
            itemCategory: "Result" /* SearchResultClickType.Result */,
            knownArea: 'SearchResults',
            searchProviderType: "All" /* SearchResultType.All */,
            searchResultType: "Template" /* SearchResultType.Template */,
            event: KnownInstrumentationEvents.SearchClick,
            elementId: "MSA_Serp_Template" /* SerpResultElementId.Template */,
            pageNav: true,
        },
    ]; },
    /**
     * File Search Page
     */
    // Logs when the user clicks on a file in the Files tab in the SERP
    'FilesSearchPanel.TriageFileSearchResult.onClick': function () { return [
        {
            itemCategory: "Result" /* SearchResultClickType.Result */,
            knownArea: 'SearchResults',
            searchProviderType: "File" /* SearchResultType.File */,
            searchResultType: "File" /* SearchResultType.File */,
            event: KnownInstrumentationEvents.SearchClick,
            elementId: "MSA_Serp_File" /* SerpResultElementId.File */,
            pageNav: true,
        },
    ]; },
    // Logs when the user clicks on a template in the Templates tab in the SERP
    'TemplatesSearchPanel.TemplateSearchResult.onClick': function () { return [
        {
            itemCategory: "Result" /* SearchResultClickType.Result */,
            knownArea: 'SearchResults',
            searchProviderType: "Template" /* SearchResultType.Template */,
            searchResultType: "Template" /* SearchResultType.Template */,
            event: KnownInstrumentationEvents.SearchClick,
            elementId: "MSA_Serp_Template" /* SerpResultElementId.Template */,
            pageNav: true,
        },
    ]; },
    /**
     * Template Search Page
     */
    // Logs when the user clicks on a template in the Templates tab in the SERP
    'CustomRefinersContainer.onRefinerClick': function (parameter) {
        var searchProviderType;
        var searchResultType;
        switch (parameter === null || parameter === void 0 ? void 0 : parameter.filterId) {
            case "all_FileType" /* SerpRefinerType.AllFileTypeRefiner */:
                searchProviderType = "All" /* SearchResultType.All */;
                searchResultType = "all_FileType" /* SerpRefinerType.AllFileTypeRefiner */;
                break;
            case "docs_FileType" /* SerpRefinerType.FileFileTypeRefiner */:
                searchProviderType = "File" /* SearchResultType.File */;
                searchResultType = "docs_FileType" /* SerpRefinerType.FileFileTypeRefiner */;
                break;
            case "templates_TemplateType" /* SerpRefinerType.TemplateFileTypeRefiner */:
                searchProviderType = "Template" /* SearchResultType.Template */;
                searchResultType = "templates_TemplateType" /* SerpRefinerType.TemplateFileTypeRefiner */;
                break;
        }
        return [
            {
                itemCategory: "Filter_Open" /* SearchResultClickType.FilterOpen */,
                knownArea: 'SearchResults',
                searchProviderType: searchProviderType,
                searchResultType: searchResultType || "Null" /* SearchResultType.Null */,
                event: KnownInstrumentationEvents.SearchCapability,
                pageNav: false,
            },
        ];
    },
    // Logs when the user submits a filter or multiple filters
    'CustomRefinersContainer.applyRefiner': function (parameter) {
        var searchProviderType;
        switch (parameter === null || parameter === void 0 ? void 0 : parameter.filterId) {
            case "all_FileType" /* SerpRefinerType.AllFileTypeRefiner */:
                searchProviderType = "All" /* SearchResultType.All */;
                break;
            case "docs_FileType" /* SerpRefinerType.FileFileTypeRefiner */:
                searchProviderType = "File" /* SearchResultType.File */;
                break;
            case "templates_TemplateType" /* SerpRefinerType.TemplateFileTypeRefiner */:
                searchProviderType = "Template" /* SearchResultType.Template */;
                break;
        }
        return [
            {
                itemCategory: "Filter_Submit" /* SearchResultClickType.FilterSubmit */,
                knownArea: 'SearchResults',
                searchProviderType: searchProviderType,
                searchResultType: "Null" /* SearchResultType.Null */,
                event: KnownInstrumentationEvents.SearchCapability,
                pageNav: false,
            },
        ];
    },
    'VerticalFiltersRoot.VerticalFilters.changeAndLog': function (parameter) {
        var searchProviderType;
        switch (parameter === null || parameter === void 0 ? void 0 : parameter.verticalId) {
            case "main" /* SerpVerticalId.All */:
                searchProviderType = "All" /* SearchResultType.All */;
                break;
            case "docs" /* SerpVerticalId.File */:
                searchProviderType = "File" /* SearchResultType.File */;
                break;
            case "templates" /* SerpVerticalId.Template */:
                searchProviderType = "Template" /* SearchResultType.Template */;
                break;
        }
        return [
            {
                itemCategory: "Vertical_Change" /* SearchResultClickType.VerticalChange */,
                knownArea: 'SearchResults',
                searchProviderType: searchProviderType,
                searchResultType: "Null" /* SearchResultType.Null */,
                event: KnownInstrumentationEvents.SearchCapability,
                pageNav: false,
            },
        ];
    },
    /**
     * Performance Logging
     */
    // Data Fetching
    ResultsRendered: function (parameter) {
        var searchProviderType;
        switch (parameter === null || parameter === void 0 ? void 0 : parameter.verticalId) {
            case "main" /* SerpVerticalId.All */:
                searchProviderType = "All" /* SearchResultType.All */;
                break;
            case "docs" /* SerpVerticalId.File */:
                searchProviderType = "File" /* SearchResultType.File */;
                break;
            case "templates" /* SerpVerticalId.Template */:
                searchProviderType = "Template" /* SearchResultType.Template */;
                break;
        }
        return [
            {
                itemCategory: "Data_Fetch_Latency" /* SearchResultClickType.DataFetchLatency */,
                knownArea: 'SearchResults',
                searchProviderType: searchProviderType,
                searchResultType: "Null" /* SearchResultType.Null */,
                event: KnownInstrumentationEvents.SearchPerformance,
            },
            {
                itemCategory: "E2E_Latency" /* SearchResultClickType.E2ELatency */,
                knownArea: 'SearchResults',
                searchProviderType: searchProviderType,
                searchResultType: "Null" /* SearchResultType.Null */,
                event: KnownInstrumentationEvents.SearchPerformance,
            },
        ];
    },
};
//# sourceMappingURL=contextToEventMapper.js.map